var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPat1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 151,
    viewBox: "0 0 170 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62668e-05 0.000320494L121.183 0.000320494L121.183 114.682C54.2898 114.682 5.62668e-05 63.3045 5.62668e-05 0.000320494Z",
    fill: "#FFB201"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.93 57.9783C147.778 57.9783 169.655 78.7029 169.655 104.138C169.655 129.572 147.778 150.297 120.93 150.297L120.93 57.9783Z",
    fill: "#1EBCB4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPat1);
export default __webpack_public_path__ + "static/media/pat1.a8a4ddad38bb914be7ef96a8f05dc0c3.svg";
export { ForwardRef as ReactComponent };